import './wishlist-modal.css';

export default () => {
  class WishlistModal extends HTMLElement {
    constructor() {
      super();
      this.wishlistClose = this.querySelector('#wishlist-modal-close');
      // Trigger is outside the panel element but inside the custom element
      this.wishlistOpen = this.querySelector('#swym-wishlist-modal');
      this.dialog = this.querySelector('#wishlist-modal');
      this.dialogRoot = this.querySelector('.header-wishlist__wrapper');

      this._onKeydown = this._onKeydown.bind(this);
      this._previouslyFocused = null;
    }

    connectedCallback() {
      this.initEventListeners();
    }

    initEventListeners() {
      this.wishlistClose.addEventListener('click', () => this.closeModal());
      this.wishlistOpen.addEventListener('click', () => this.openModal());

      // Support keyboard activation on the trigger
      this.wishlistOpen.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.openModal();
        }
      });

      // Clicking the scrim closes the dialog
      this.addClickOutsideListener();

      // Clicking the overlay layer closes as well
      this.querySelectorAll('.wishlist-layer').forEach(layer => {
        layer.addEventListener('click', () => this.closeModal());
      });
    }

    addClickOutsideListener() {
      const bg = this.querySelector('.slide-panel__bg');
      if (!bg) return;
      bg.addEventListener('click', () => {
        if (this.dialog.getAttribute('default-open') === 'true') {
          this.closeModal();
        }
      });
    }

    getFocusableElements(container) {
      const all = container.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      return [...all].filter(el => {
        const style = window.getComputedStyle(el);
        return style.visibility !== 'hidden' && style.display !== 'none' && !el.closest('.hidden');
      });
    }

    trapFocus() {
      const tabbables = this.getFocusableElements(this.dialogRoot || this.dialog);
      if (tabbables.length === 0) return;
      // eslint-disable-next-line
      this.firstFocusable = tabbables[0];
      this.lastFocusable = tabbables[tabbables.length - 1];

      // Move focus into the dialog. Prefer the close button if present.
      const initial = this.wishlistClose || this.firstFocusable;
      initial.focus();

      document.addEventListener('keydown', this._onKeydown);
    }

    _onKeydown(e) {
      if (e.key === 'Tab') {
        const active = document.activeElement;
        if (e.shiftKey) {
          if (active === this.firstFocusable) {
            e.preventDefault();
            this.lastFocusable.focus();
          }
        } else {
          // eslint-disable-next-line
          if (active === this.lastFocusable) {
            e.preventDefault();
            this.firstFocusable.focus();
          }
        }
      }
      if (e.key === 'Escape') {
        e.preventDefault();
        this.closeModal();
      }
    }

    openModal() {
      this._previouslyFocused = document.activeElement;

      // Show dialog
      this.dialog.setAttribute('default-open', 'true');
      this.wishlistOpen.setAttribute('aria-expanded', 'true');
      document.body.classList.add('overflow-hidden');

      // If your CSS relies on toggling the "hidden" class, remove it here
      this.dialog.classList.remove('hidden');

      this.loadWishlist();
      this.trapFocus();
    }

    closeModal() {
      this.dialog.setAttribute('default-open', 'false');
      this.wishlistOpen.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('overflow-hidden');

      // Mirror the open logic if "hidden" matters to layout/visibility
      this.dialog.classList.add('hidden');

      document.removeEventListener('keydown', this._onKeydown);

      if (this._previouslyFocused && typeof this._previouslyFocused.focus === 'function') {
        this._previouslyFocused.focus();
      }
    }

    loadWishlist() {
      const onSuccess = (lists) => {
        const productDataDivs = document.querySelectorAll('.productData');
        if (lists.length > 0) {
          this.querySelector('#wishlist-products-count').innerHTML = `(${lists[0].listcontents.length})`;
        }

        productDataDivs.forEach((productDataDiv) => {
          // eslint-disable-next-line
          productDataDiv.innerHTML = '';
          if (lists.length > 0 && lists[0].listcontents.length > 0) {
            lists[0].listcontents.forEach((product) => {
              const productElement = this.createProductElement(product);
              productDataDiv.appendChild(productElement);
            });
          } else {
            // eslint-disable-next-line
            productDataDiv.innerHTML = '<div class="py-5 px-5 empty-cart-text"><p>Wishlist is empty</p></div>';
          }
        });
      };

      const onError = (error) => {
        // eslint-disable-next-line no-console
        console.log("Error while fetching all Lists", error);
      }


      function onSwymLoadCallback(swat) {
        swat.fetchLists({ callbackFn: onSuccess, errorFn: onError });

        setTimeout(() => {
          document.querySelectorAll('.wishlist-item-remove').forEach(item => {
            item.addEventListener('click', () => {
              const lid = item.getAttribute('data-lid');
              const product = {
                epi: item.getAttribute('data-epi'),
                empi: item.getAttribute('data-empi'),
                du: item.getAttribute('data-du')
              };
              const onSuccessDelete = () => window.location.reload();
              const onErrorDelete = (error) => console.log('Error while deleting the Product', error);
              swat.deleteFromList(lid, product, onSuccessDelete, onErrorDelete);
            });
          });
        }, 1000);
      }

      window.SwymCallbacks = window.SwymCallbacks || [];
      window.SwymCallbacks.push(onSwymLoadCallback);
    }

    createProductElement(product) {
      const productElement = document.createElement('div');
      const formattedPrice = new Intl.NumberFormat(`en-${Shopify.country}`, {
        style: 'currency',
        currency: `${Shopify.currency.active}`
      }).format(product.pr * Shopify.currency.rate);

      productElement.innerHTML = `
      <div class="flex border-b border-light_gray w-full px-4 gap-3" data-section="cart-item">
        <div class="shrink-0">
          <a href="${product.du}">
            <picture class="w-[100px] inline-block">
              <source srcset="${product.iu}?v=1672868156&amp;width=1536 1536w" media="(min-width: 640px)">
              <img class="w-full image" src="${product.iu}" alt="" loading="lazy">
            </picture>
          </a>
        </div>
        <div class="py-4 grow">
          <h3 class="pdp__title font-regular text-16 leading-21px mb-8 flex justify-between items-start gap-2">
            <a href="${product.du}" class="hover:no-underline">
              <em>${product.dt}</em><br>
              <span></span>
            </a>
            <span class="body-4 shrink-0">${formattedPrice}</span>
          </h3>
          <dl role="presentation">
            <div class="product-option body-4 flex items-center">
              <dt class="uppercase">${product.vi}</dt>
              <dd class="uppercase"></dd>
            </div>
          </dl>
          <div class="cart-item__quantity-wrapper quantity-popover-wrapper flex justify-between items-center">
            <div class="quantity-selector">
              <form method="post" action="/cart/add" class="wishlist-add-to-cart">
                <input type="hidden" name="id" value="${product.epi}" />
                <input type="submit" value="Add To Bag" />
              </form>
            </div>
            <button type="button"
              class="button--tertiary cart-remove-button body-4 wishlist-item-remove"
              data-lid="${product.lid}" data-epi="${product.epi}" data-empi="${product.empi}" data-du="${product.du}">
              Delete
            </button>
          </div>
        </div>
      </div>
    `;
      return productElement;
    }
  }

  const init = () => {
    if (!customElements.get("wishlist-modal")) {
      customElements.define('wishlist-modal', WishlistModal);
    }
  };

  init();
};
